import { getActiveModule } from "../moduleConfig";
import { normalizeUrlPath } from "./policies";

const RH_READABLE_RESOURCES =
  /^(students|student|staffs|sections|sectionclasses|sectionclasselessons|years|year|years_|yearslist|yearslistetabli|classes|profiles|permissions|parentfamilies|suppliers|establishments|establishmentprofiles|categorystudents|countries|territories|communes|groupments|quartiers|reportcardcategories|reportcards|months|days|leaves|schedules|presences|daystaffs|schoolfees|lessons|evaluations|expenses|wages|borrows|sectschoolcatstudcats|estsectschoolcatstudcats)(\/|$)/i;

const RH_MUTABLE_RESOURCES =
  /^(students|staffs|sections|sectionclasses|leaves|presences|daystaffs|parentfamilies|suppliers|territories|communes|groupments|quartiers)(\/[^/]+)?\/?$/i;

// GET /presences is not declared by the API. The documented read route requires
// a numeric month, so preload every valid month instead of requesting a 404.
const RH_PRESENCE_MONTH_RESOURCES = Array.from(
  { length: 12 },
  (_, index) => `presences/${index + 1}`
);

const COMPTA_READABLE_RESOURCES =
  /^(accountingbalances|categorystudents|chartaccounts|classes|expenses|expensedetails|gifts|months|schoolfee|schoolfees|schoolfeecategories|schoolfeecategories_|sectionclasses|sections|staffs|students|suppliers|transports|trimesters|typesalaries|users|year|years)(\/|$)/i;

const COMPTA_MUTABLE_RESOURCES =
  /^(chartaccounts|expenses|expensedetails|gifts|schoolfees|schoolfeecategories|sectionschoolfeecategories|estsectschoolcatstudcats|transports|typesalaries|users_)(\/[^/]+)?\/?$/i;
export const OFFLINE_MODULE_POLICIES = {
  rh: {
    enabled: true,
    preloadVersion: 5,
    readableResources: RH_READABLE_RESOURCES,
    mutableResources: RH_MUTABLE_RESOURCES,
    queuedMethods: ["post", "put"],
    preloadResources: [
      'years_',
      'yearslist',
      'yearslistetabli',
      'parentfamilies',
      'suppliers',
      'profiles',
      'territories',
      'communes',
      'groupments',
      'quartiers',
      'reportcardcategories',
      'months',
      'days',
      'leaves',
      'schedules',
      ...RH_PRESENCE_MONTH_RESOURCES,
      "years",
      "sections",
      "sectionclasses",
      "classes",
      "students",
      "staffs",
    ],
  },
  compta: {
    enabled: true,
    preloadVersion: 2,
    readableResources: COMPTA_READABLE_RESOURCES,
    mutableResources: COMPTA_MUTABLE_RESOURCES,
    queuedMethods: ["post", "put"],
    preloadResources: [
      "years",
      "months",
      "trimesters",
      "sections",
      "sectionclasses",
      "classes",
      "students",
      "categorystudents",
      "suppliers",
      "staffs",
      "users",
      "chartaccounts",
      "typesalaries",
      "schoolfeecategories",
      "schoolfeecategories_",
      "transports",
      "gifts",
      "expenses",
      "expenses/operation/all",
      "schoolfees",
      "accountingbalances",
    ],
  },
  stat: {
    enabled: false,
    readableResources: null,
    mutableResources: null,
    queuedMethods: [],
    preloadResources: [],
  },
  biblio: {
    enabled: false,
    readableResources: null,
    mutableResources: null,
    queuedMethods: [],
    preloadResources: [],
  },
};

export const getOfflineModulePolicy = (moduleName = getActiveModule()) =>
  OFFLINE_MODULE_POLICIES[moduleName] || {
    enabled: false,
    preloadVersion: 0,
    readableResources: null,
    mutableResources: null,
    queuedMethods: [],
    preloadResources: [],
  };

export const canCacheOfflineRequest = (config, moduleName = getActiveModule()) => {
  const policy = getOfflineModulePolicy(moduleName);
  const method = (config?.method || "get").toLowerCase();

  return (
    policy.enabled &&
    method === "get" &&
    Boolean(policy.readableResources?.test(normalizeUrlPath(config?.url)))
  );
};

export const canQueueOfflineMutation = (
  config,
  moduleName = getActiveModule()
) => {
  const policy = getOfflineModulePolicy(moduleName);
  const method = (config?.method || "get").toLowerCase();
  const pathParts = normalizeUrlPath(config?.url).split("/").filter(Boolean);
  const isCrudRoute =
    (method === "post" && pathParts.length === 1) ||
    (method === "put" && pathParts.length === 2);

  return (
    policy.enabled &&
    policy.queuedMethods.includes(method) &&
    isCrudRoute &&
    Boolean(policy.mutableResources?.test(normalizeUrlPath(config?.url))) &&
    !config?.offlineReplay
  );
};

export const isBlockedOfflineDelete = (
  config,
  moduleName = getActiveModule()
) => {
  const policy = getOfflineModulePolicy(moduleName);
  const method = (config?.method || "get").toLowerCase();

  return (
    policy.enabled &&
    method === "delete" &&
    Boolean(policy.mutableResources?.test(normalizeUrlPath(config?.url)))
  );
};
